import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

//Styles
import "./Navbar.css";

//Context
import { NavbarContext } from "../../context/NavbarContext";
import { LanguageContext } from "../../context/LanguageContext";

const Navbar = () => {
  const { t } = useTranslation();

  const [viewMenu, setViewMenu] = useState(false);

  const { propDevsInView, energyInView, roadInView, industrialInView } =
    useContext(NavbarContext);

  const { traslate, toggleLanguage } = useContext(LanguageContext);

  return (
    <nav className="nb-container">
      <Link to="/" className="nb-logo-container">
        <img
          src={
            roadInView
              ? "https://pagina-otacc.s3.amazonaws.com/pages/otacc-page/assets/icons/logo-otacc-white.webp"
              : "https://pagina-otacc.s3.amazonaws.com/pages/otacc-page/assets/icons/logo-otacc.webp"
          }
          alt="Logo Otacc"
          className="nb-logo-img"
        />
      </Link>
      <div className="nb-menus-supercontainer">
        <div className="nb-menus-container-nm">
          <a
            href="#property"
            className={`nb-option ${propDevsInView ? "current" : ""}`}
          >
            {t("navbar.title_1")}
          </a>
          <a
            href="#industrial"
            className={`nb-option ${industrialInView ? "current" : ""}`}
          >
            {t("navbar.title_2")}
          </a>
          <a
            href="#energy"
            className={`nb-option ${energyInView ? "current" : ""}`}
          >
            {t("navbar.title_3")}
          </a>
          <a
            href="#road"
            className={`nb-option ${roadInView ? "current" : ""}`}
          >
            {t("navbar.title_4")}
          </a>
          <Link to="/nosotros" className="nb-option">
            {t("navbar.title_5")}
          </Link>
        </div>
        <div className="nb-menus-mobile-container">
          <img
            onClick={() => setViewMenu(!viewMenu)}
            src="https://pagina-otacc.s3.amazonaws.com/pages/otacc-page/assets/ham-menu-icon.webp"
            alt=""
            className="ham-icon"
          />
          <div
            className={`mb-menus-container ${viewMenu ? "" : "closed-menu"}`}
          >
            <a
              href="#property"
              className="nb-option"
              onClick={() => setViewMenu(false)}
            >
              {t("navbar.title_1")}
            </a>
            <a
              href="#industrial"
              className="nb-option"
              onClick={() => setViewMenu(false)}
            >
              {t("navbar.title_2")}
            </a>
            <a
              href="#energy"
              className="nb-option"
              onClick={() => setViewMenu(false)}
            >
              {t("navbar.title_3")}
            </a>
            <a
              href="#road"
              className="nb-option"
              onClick={() => setViewMenu(false)}
            >
              {t("navbar.title_4")}
            </a>
            <Link to="/nosotros" className="nb-option">
              {t("navbar.title_5")}
            </Link>
          </div>
        </div>
        <div>
          <button className="nb-language-btn" onClick={toggleLanguage}>
            <img
              src={`https://flagcdn.com/w40/${!traslate ? "co" : "us"}.png`}
              alt={!traslate ? "Colombia" : "USA"}
              width="20"
              style={{ verticalAlign: "middle", marginRight: 8 }}
            />
            {!traslate ? "ES" : "EN"}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
